import { useParams } from "react-router-dom";
import { query } from "../../../util/api/query";
import type { PriceTypeDto } from "../types/PromotionDto";

export function usePriceTypeOptions() {
    const { organisation } = useParams();

    const priceTypesQuery = query<PriceTypeDto[]>(
        `${organisation}/promotions/types`,
    );

    return priceTypesQuery;
}